import { render, staticRenderFns } from "./FormSettings.vue?vue&type=template&id=88eb8c28&"
import script from "./FormSettings.vue?vue&type=script&lang=js&"
export * from "./FormSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports